import Footer from "./components/Footer";
import About from "./Pages/Extras/About";
import Contact from "./Pages/Extras/Contact";
import Features from "./Pages/Extras/Features";
import Header from "./components/Header";


import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './Pages/Auth/Login';
import Register from './Pages/Auth/Register';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Pages/Home/Home';
import SetAvatar from './Pages/Avatar/setAvatar';

<>
  <Header />

  <Routes>
    <Route path="/home" element={<Home />} />
    <Route path="/features" element={<Features />} />
    <Route path="/about" element={<About />} />
  </Routes>
</>

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/home" element={<Home />} />
          <Route path="/setAvatar" element={<SetAvatar />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/features" element={<Features />} />

        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
